/**
 * 安聆 SafeListen - 国际化配置
 * 品牌名「安聆 SafeListen」所有语言统一不翻译
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './translations/zh.json';
import zhTW from './translations/zh-TW.json';
import en from './translations/en.json';
import es from './translations/es.json';
import fr from './translations/fr.json';
import de from './translations/de.json';
import ja from './translations/ja.json';
import pt from './translations/pt.json';
import ko from './translations/ko.json';
import ar from './translations/ar.json';
import it from './translations/it.json';
import ru from './translations/ru.json';
import vi from './translations/vi.json';
import th from './translations/th.json';
import id from './translations/id.json';

const savedLang = typeof localStorage !== 'undefined' ? localStorage.getItem('safelisten-lang') : null;

i18n.use(initReactI18next).init({
  resources: {
    zh: { translation: zh },
    'zh-TW': { translation: zhTW },
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
    ja: { translation: ja },
    pt: { translation: pt },
    ko: { translation: ko },
    ar: { translation: ar },
    it: { translation: it },
    ru: { translation: ru },
    vi: { translation: vi },
    th: { translation: th },
    id: { translation: id },
  },
  lng: savedLang || 'zh',
  fallbackLng: 'zh',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof localStorage !== 'undefined') localStorage.setItem('safelisten-lang', lng);
});

export default i18n;
